import React from "react";
import { motion } from "framer-motion";

const Hero = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      const navbarHeight = 50;
      const animationOffset = 38;
      const elementPosition = aboutSection.getBoundingClientRect().top;
      const offsetPosition = window.pageYOffset + elementPosition - navbarHeight - animationOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const scrollToFeatures = () => {
    const featuresSection = document.getElementById("features");
    if (featuresSection) {
      const navbarHeight = 70;
      const elementPosition = featuresSection.getBoundingClientRect().top;
      const offsetPosition = window.pageYOffset + elementPosition - navbarHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <header className="relative w-full h-screen overflow-hidden font-sans">
      {/* Background Video */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        src="/green.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-10" />

      <div className="relative z-20 flex flex-col justify-center items-center text-center h-full px-6 max-w-5xl mx-auto">
        {/* Animated Title */}
        <motion.h1
          initial={{ opacity: 0, y: 25, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold max-w-4xl leading-tight tracking-tight drop-shadow-[0_4px_16px_rgba(0,0,0,0.9)] text-white"
          style={{ display: "inline-block" }}
        >
          <span className="text-white">Pure Prakruti: </span>
          <span className="bg-gradient-to-r from-emerald-400 via-teal-300 to-emerald-200 bg-clip-text text-transparent">
            Sustainable Logistics for a Better Tomorrow
          </span>
        </motion.h1>

        {/* Animated Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25, ease: "easeOut" }}
          className="mt-4 md:mt-6 text-emerald-100/95 text-base sm:text-xl md:text-2xl max-w-3xl font-medium leading-relaxed drop-shadow-[0_2px_8px_rgba(0,0,0,0.85)]"
        >
          Join the revolution in road logistics by reducing carbon emissions and
          ensuring compliance with global environmental standards.
        </motion.p>

        {/* Floating AI Badge */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: [0, -5, 0] }}
          transition={{
            opacity: { duration: 0.6, delay: 0.4 },
            y: { duration: 3, repeat: Infinity, ease: "easeInOut" }
          }}
          whileHover={{ scale: 1.08 }}
          className="mt-6 flex items-center bg-white/10 border border-white/25 backdrop-blur-xl px-4 py-1.5 rounded-full shadow-lg cursor-pointer"
        >
          <span className="text-emerald-400 mr-2 text-lg md:text-xl">✨</span>
          <span className="text-white text-sm md:text-base font-semibold tracking-wide">
            Powered by AI
          </span>
        </motion.div>

        {/* Animated Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
          className="mt-8 md:mt-10 flex flex-wrap justify-center gap-4 sm:gap-6"
        >
          <motion.div
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToFeatures}
          >
            <button className="bg-emerald-600 hover:bg-emerald-500 text-white text-sm md:text-lg font-bold py-3.5 px-7 md:py-4 md:px-10 rounded-xl shadow-xl transition border border-emerald-400/30">
              Explore Our Solutions
            </button>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToAbout}
          >
            <button className="border-2 border-white/80 bg-white/10 hover:bg-white hover:text-emerald-900 backdrop-blur-md text-white text-sm md:text-lg font-bold py-3.5 px-7 md:py-4 md:px-10 rounded-xl shadow-lg transition">
              Learn More
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Floating Animated Down Arrow */}
      <motion.div
        onClick={scrollToAbout}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 8, 0] }}
        transition={{
          opacity: { duration: 1, delay: 0.8 },
          y: { duration: 2, repeat: Infinity, ease: "easeInOut" }
        }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer z-20"
        aria-label="Scroll down to About section"
      >
        <div className="w-12 h-12 rounded-full bg-white/10 border border-white/20 backdrop-blur-md flex items-center justify-center text-white shadow-lg hover:bg-white/20 transition">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-emerald-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </motion.div>
    </header>
  );
};

export default Hero;
